import { Controller } from '@hotwired/stimulus';
import { MDCDialog } from '@material/dialog';

export default class extends Controller {
  static targets = ['dialogBody', 'dialog'];
  static values = {
    newUrl: String
  };

  dialogTargetConnected() {
    this.dialog = new MDCDialog(this.dialogTarget);
  }

  new(e) {
    e.preventDefault();
    console.log(this.newUrlValue);
    this.loadForm(this.newUrlValue);
  }

  edit(e) {
    e.preventDefault();
    this.loadForm(e.target.dataset.strategyNoteEditUrl);
  }

  loadForm(url) {
    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        this.dialogBodyTarget.innerHTML = html;
        this.dialog.open();
      });
  }
}
